var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.479,
    height: 24.479,
    viewBox: "0 0 24.479 24.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(-6.807 -6.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M31.079,30.071,25.516,24.51a10.723,10.723,0,1,0-1.007,1.006l5.562,5.562a.712.712,0,1,0,1.007-1.007ZM10.941,24.031a9.255,9.255,0,1,1,6.545,2.711,9.2,9.2,0,0,1-6.545-2.711Z",
    transform: "translate(0)",
    fill: "#dbdbdb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search (2).1b89abd4f2c543f539665cd3e52d90e4.svg";
export { ForwardRef as ReactComponent };